import React, {
  ReactNode,
} from 'react';
import clsx from 'clsx';

type Props = {
  title: ReactNode;
  children: ReactNode;
  className?: string;
};

export default function Section({ title, children, className }: Props) {
  return (
    <div className={clsx('p-4 border border-gray-200 rounded-lg', className)}>
      <div className="text-sm font-semibold text-gray-700 mb-3">{title}</div>
      {children}
    </div>
  );
}
